// app/javascript/controllers/hierarchy_tree_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevron", "continentContent"]

  connect() {
    // Initialiser l'état fermé pour tous les continents
    this.continentContentTargets.forEach(content => {
      content.classList.add("hidden")
    })
  }

  toggleContinent(event) {
    const button = event.currentTarget
    const continentId = button.dataset.target.replace('continent-', '')
    const content = this.continentContentTargets.find(el => 
      el.dataset.continentId === continentId
    )
    const chevron = this.chevronTargets.find(el => 
      el.dataset.continentId === continentId
    )

    if (content && chevron) {
      const isHidden = content.classList.contains("hidden")
      
      if (isHidden) {
        // Ouvrir
        content.classList.remove("hidden")
        chevron.style.transform = "rotate(90deg)"
        this.animateOpen(content)
      } else {
        // Fermer
        this.animateClose(content, () => {
          content.classList.add("hidden")
          chevron.style.transform = "rotate(0deg)"
        })
      }
    }
  }

  expandAll() {
    this.continentContentTargets.forEach((content, index) => {
      setTimeout(() => {
        if (content.classList.contains("hidden")) {
          const continentId = content.dataset.continentId
          const chevron = this.chevronTargets.find(el => 
            el.dataset.continentId === continentId
          )
          
          content.classList.remove("hidden")
          if (chevron) {
            chevron.style.transform = "rotate(90deg)"
          }
          this.animateOpen(content)
        }
      }, index * 100) // Décalage pour un effet en cascade
    })
  }

  collapseAll() {
    this.continentContentTargets.forEach((content, index) => {
      setTimeout(() => {
        if (!content.classList.contains("hidden")) {
          const continentId = content.dataset.continentId
          const chevron = this.chevronTargets.find(el => 
            el.dataset.continentId === continentId
          )
          
          this.animateClose(content, () => {
            content.classList.add("hidden")
            if (chevron) {
              chevron.style.transform = "rotate(0deg)"
            }
          })
        }
      }, index * 50) // Décalage plus court pour la fermeture
    })
  }

  animateOpen(element) {
    // Animation d'ouverture fluide
    element.style.opacity = "0"
    element.style.transform = "translateY(-10px)"
    element.style.transition = "opacity 0.3s ease, transform 0.3s ease"
    
    // Forcer le recalcul du style
    element.offsetHeight
    
    element.style.opacity = "1"
    element.style.transform = "translateY(0)"
    
    // Nettoyer les styles inline après l'animation
    setTimeout(() => {
      element.style.opacity = ""
      element.style.transform = ""
      element.style.transition = ""
    }, 300)
  }

  animateClose(element, callback) {
    // Animation de fermeture fluide
    element.style.transition = "opacity 0.2s ease, transform 0.2s ease"
    element.style.opacity = "0"
    element.style.transform = "translateY(-10px)"
    
    setTimeout(() => {
      element.style.opacity = ""
      element.style.transform = ""
      element.style.transition = ""
      if (callback) callback()
    }, 200)
  }

  // Gérer les raccourcis clavier
  keydown(event) {
    switch(event.key) {
      case 'e':
      case 'E':
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault()
          this.expandAll()
        }
        break
      case 'r':
      case 'R':
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault()
          this.collapseAll()
        }
        break
    }
  }

  // Méthodes utilitaires pour l'état
  isExpanded(continentId) {
    const content = this.continentContentTargets.find(el => 
      el.dataset.continentId === continentId
    )
    return content && !content.classList.contains("hidden")
  }

  getExpandedContinents() {
    return this.continentContentTargets
      .filter(content => !content.classList.contains("hidden"))
      .map(content => content.dataset.continentId)
  }

  // Sauvegarder l'état dans localStorage
  saveState() {
    const expandedContinents = this.getExpandedContinents()
    localStorage.setItem('hierarchy_expanded_continents', JSON.stringify(expandedContinents))
  }

  // Restaurer l'état depuis localStorage
  restoreState() {
    const saved = localStorage.getItem('hierarchy_expanded_continents')
    if (saved) {
      try {
        const expandedContinents = JSON.parse(saved)
        expandedContinents.forEach(continentId => {
          const content = this.continentContentTargets.find(el => 
            el.dataset.continentId === continentId
          )
          const chevron = this.chevronTargets.find(el => 
            el.dataset.continentId === continentId
          )
          
          if (content && chevron) {
            content.classList.remove("hidden")
            chevron.style.transform = "rotate(90deg)"
          }
        })
      } catch (e) {
      }
    }
  }

  disconnect() {
    // Sauvegarder l'état quand on quitte la page
    this.saveState()
  }
}